import { emailRules, floatRules, phoneNumberRules } from "./regex";
import $ from "jquery";

const validation = () => {
  const onSubmit = (e, thisForm) => {
    const form = e.target;

    const input = thisForm.find(`input`);

    let isValid = {};
    let countRadio = {};
    input.each(function () {
      const type = thisForm.attr("type");
      const c_type = thisForm.data("type");
      const isRequired = thisForm.prop("required");
      const isDisabled = thisForm.prop("disabled");

      if (isDisabled) return;

      const value = thisForm.val();
      const id = thisForm.attr("id");

      const handleCondition = (condition) => {
        if (condition) {
          isValid[id] = "invalid";
        } else {
          delete isValid[id];
        }
      };

      switch (c_type) {
        case "float":
          handleCondition(!floatRules.test(value));
          break;

        default:
          break;
      }

      switch (type) {
        case "email":
          handleCondition(!emailRules.test(value));
          break;
        case "radio":
          if (thisForm.prop("checked") === true) {
            countRadio[id] = "valid";
          } else {
            delete countRadio[id];
          }
          handleCondition(Object.values(countRadio).length === 0);
          break;
        case "tel":
          handleCondition(!phoneNumberRules.test(value) && value !== "");
          break;
        case "file":
          if (isRequired)
            handleCondition(!this.files || this.files.length === 0);
          break;

        default:
          break;
      }
    });

    if (!form.checkValidity() || Object.values(isValid).length > 0) {
      e.preventDefault();
      e.stopPropagation();
      form.classList.add("Form--Validated");
      return false;
    }
    return true;
  };

  const onInput = (el) => {
    $(document).on(
      "input",
      `${el} input, ${el} select, ${el} textarea`,
      function () {
        const c_type = $(this).data("type");
        const type = $(this).attr("type");
        const value = $(this).val();

        const handleCondition = (condition) => {
          if (condition) {
            $(this).addClass("invalid");
            $(this).parent(".FormField").addClass("invalid");
          } else {
            $(this).removeClass("invalid");
            $(this).parent(".FormField").removeClass("invalid");
          }
        };

        switch (c_type) {
          case "float":
            handleCondition(!floatRules.test(value));
            break;

          default:
            break;
        }

        switch (type) {
          case "email":
            handleCondition(!emailRules.test(value));
            break;
          case "tel":
            handleCondition(!phoneNumberRules.test(value) && value !== "");
            break;

          default:
            break;
        }
      }
    );
  };

  return {
    onSubmit,
    onInput,
  };
};

export default validation;
